import { useGetProfileData } from "_common/hooks/auth";

import Presentation from "./presentation";

const component = props => {
	const userProfile = useGetProfileData ();

	return (
		<Presentation
			{ ...props }
			userProfile = { userProfile }
		/>

	);
};

export default component;
